import React from 'react'
import _ from 'lodash'

export default class AlertFilters extends React.Component {

    constructor(props) {
        super(props);

        this.serversContainer = null;

        this.state = {
            expandServers: false,
        };
    }

    componentDidMount() {
        document.addEventListener("keydown", this.closeOnEscape);
        document.addEventListener("click", this.clonseOnOutsideClick);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.closeOnEscape);
        document.removeEventListener("click", this.clonseOnOutsideClick);
    }

    toggleExpandServers = (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.setState({ expandServers: !this.state.expandServers });
    }

    debouncedSearch = _.debounce((search) => {
        this.props.setSearch(search);
    }, 500);

    closeOnEscape = (e) => {
        if (e.key === "Escape" && this.state.expandServers) {
            this.setState({ expandServers: false });
        }
    }

    clonseOnOutsideClick = (e) => {
        if (this.serversContainer && !this.serversContainer.contains(e.target) && this.state.expandServers) {
            this.setState({ expandServers: false });
        }
    }

    render() {
        const {
            availableServers,
            ignoredServers,
            toggleServer,
            ignoreNoServers,
            ignoreAllServers,
            displayGroupAlerts,
        } = this.props;

        return (
            <div
                className="alert-filters"
                onClick={(e) => e.stopPropagation()}
            >
                <div
                    ref={r => this.serversContainer = r}
                    className="servers-container"
                >
                    <button onClick={this.toggleExpandServers}>
                        {availableServers.length > 0 ? `Showing ${Math.max(availableServers.length - ignoredServers.length, 0)} of ${availableServers.length} servers` : ""}
                    </button>
                    {this.state.expandServers && (
                        <div
                            className="servers"
                            
                        >
                            <div className="all-none">
                                <div onClick={ignoreNoServers}>ALL</div>
                                <div onClick={ignoreAllServers}>NONE</div>
                            </div>
                            {availableServers.map((server) => {
                                const checked = !ignoredServers.includes(server);
                                return (
                                    <div
                                        key={server}
                                        className={`server ${checked ? "checked" : ""}`}
                                        onClick={() => toggleServer(server)}
                                    >
                                        {server}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
                <div className="search">
                    <input
                        type="search"
                        placeholder="Filter services"
                        defaultValue={this.props.search}
                        onChange={(e) => this.debouncedSearch(e.target.value)}
                    />
                </div>
                {displayGroupAlerts && (
                    <div className="group-alerts">
                        <input
                            id="group-alerts"
                            type="checkbox"
                            checked={this.props.groupAlerts}
                            onChange={this.props.toggleGroupAlerts}
                        />
                        <label htmlFor="group-alerts"> Group alerts</label>
                    </div>
                )}
                <button onClick={this.props.onSubscriptionsClick}>Subscriptions</button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/alertFilters.jsx